// @ts-check

export default class ComponentHandler {
  constructor(options) {
    this.components = options.components;

    // run components initialation on page load
    window.addEventListener('DOMContentLoaded', () => {
      this.initializeAll();
    });

    // run components initialation if some dom elements created after page load
    document.addEventListener('reinitializeComponents', () => {
      this.initializeAll();
    });
  }

  initializeAll() {
    this.components.forEach(component => {
      // get all not initialized elements of component type
      let allNotInitializedElements = document.querySelectorAll(`[data-component="${component.name}"]:not(.is-initialized)`);

      for (let i = 0; i < allNotInitializedElements.length; ++i) {
        // create component
        new component.definition(allNotInitializedElements[i]);
      }
    });
  }
}